/* CSV reports (same columns as api/internal/api/h_reports.go). */
import { eosb } from "../../domain/payroll";
import { E, fmtMoney, fmtNum, type Ctx } from "./ctx";
import { dayView, runView } from "./derived";
import { csvRows } from "./payroll";

export type ReportKind = "register" | "gosi" | "eosb" | "employees" | "attendance";

export function reportsOps(c: Ctx) {
  return {
    async reportCsv(kind: ReportKind): Promise<string> {
      c.principal("reports");
      const es = c.employeesSorted();
      const byId = new Map(es.map((e) => [e.id, e]));
      const rows: string[][] = [];
      switch (kind) {
        case "employees":
          rows.push(["Code", "Name (EN)", "Name (AR)", "Nationality", "Department", "Title", "Branch", "Basic", "Housing", "Transport", "Joined", "Status"]);
          for (const e of es) rows.push([e.code, e.nameEn, e.nameAr, e.nationality, e.dept, e.title, e.branch, fmtMoney(e.basic), fmtMoney(e.housing), fmtMoney(e.transport), e.joined, e.status]);
          break;
        case "register": {
          const v = runView(c);
          rows.push(["Period", "Code", "Name", "Basic", "Housing", "Transport", "Other", "OT Hours", "OT", "Bonus", "Absence", "Deductions (other)", "Loan", "GOSI Employee", "Earnings", "Deductions", "Net"]);
          for (const s of v.slips) {
            const e = byId.get(s.employeeId)!;
            rows.push([s.period, e.code, e.nameEn, fmtMoney(s.basic), fmtMoney(s.housing), fmtMoney(s.transport), fmtMoney(s.other), fmtNum(s.otHours), fmtMoney(s.ot), fmtMoney(s.bonus), fmtMoney(s.abs), fmtMoney(s.ded), fmtMoney(s.loan), fmtMoney(s.gosi.emp), fmtMoney(s.earnings), fmtMoney(s.deductions), fmtMoney(s.net)]);
          }
          const t = v.totals;
          rows.push([v.run.period, "TOTAL", `${t.headcount} employees`, "", "", "", "", "", fmtMoney(t.ot), fmtMoney(t.bonus), "", "", "", fmtMoney(t.gosiEmp), fmtMoney(t.gross), fmtMoney(t.deductions), fmtMoney(t.net)]);
          break;
        }
        case "gosi": {
          const v = runView(c);
          rows.push(["Code", "Name", "Nationality", "Regime", "Contribution base", "Annuity rate", "Employee", "Employer", "Total"]);
          for (const s of v.slips) {
            const e = byId.get(s.employeeId)!;
            const g = s.gosi;
            rows.push([e.code, e.nameEn, e.nationality, g.regime, fmtMoney(g.base), fmtNum(g.annRate), fmtMoney(g.emp), fmtMoney(g.er), fmtMoney(g.emp + g.er)]);
          }
          break;
        }
        case "eosb":
          rows.push(["Code", "Name", "Joined", "Years", "Wage", "Full award (termination)", "Award if resigning"]);
          for (const e of c.active()) {
            const t = eosb(e, c.today, "termination", 0, c.country), r = eosb(e, c.today, "resignation", 0, c.country);
            rows.push([e.code, e.nameEn, e.joined, fmtNum(t.years), fmtMoney(t.wage), fmtMoney(t.award), fmtMoney(r.award)]);
          }
          break;
        case "attendance": {
          const v = dayView(c, c.today);
          rows.push(["Date", "Code", "Name", "First in", "Last out", "Worked minutes", "Late minutes", "Overtime minutes", "Punches", "Status", "Source"]);
          for (const r of v.rows) {
            const e = byId.get(r.employeeId)!;
            rows.push([r.date, e.code, e.nameEn, r.firstIn ?? "", r.lastOut ?? "", String(r.workedMinutes), String(r.lateMinutes), String(r.overtimeMinutes), String(r.punches), r.status, r.source]);
          }
          break;
        }
        default:
          throw E.notFound("report not found");
      }
      return csvRows(rows);
    },
  };
}
